exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-title[data-v-93396ace]{font-size:1.75rem;font-weight:700;text-align:center;color:#212529}table td[data-v-93396ace]{border-width:0;padding:.5rem}.col1[data-v-93396ace]{text-align:right;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-93396ace&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/EmployeeDetails.vue
// module id = 245
// module chunks = 0